export const overlay = (isOverlayToggled, isOverlayWechatToggled) => {
  const overlay = document.querySelector(".js-overlay");
  const btnToggleOverlay = document.querySelector(".js-overlay-toggle");
  const btnCloseOverlay = document.querySelector(".js-overlay-close");

  const overlayWechat = document.querySelector(".js-overlay-wechat");
  const btnToggleOverlayWechat = document.querySelector(".js-overlay-wechat-toggle");
  const btnCloseOverlayWechat = document.querySelector(".js-overlay-wechat-close");

  const init = () => {
    updateOverlayState();
    bind();
  };

  function triggerFocus(element) {
    var eventType = "onfocusin" in element ? "focusin" : "focus",
      bubbles = "onfocusin" in element,
      event;

    if ("createEvent" in document) {
      event = document.createEvent("Event");
      event.initEvent(eventType, bubbles, true);
    } else if ("Event" in window) {
      event = new Event(eventType, { bubbles: bubbles, cancelable: true });
    }

    element.focus();
    element.dispatchEvent(event);
  }

  const bind = () => {
    if (btnToggleOverlay) {
      btnToggleOverlay.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isOverlayToggled = !isOverlayToggled;
        updateOverlayState();

        var messageField = document.getElementById("text");
        triggerFocus(messageField);

      };
    }
    if (btnCloseOverlay) {
      btnCloseOverlay.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isOverlayToggled = !isOverlayToggled;
        updateOverlayState();
      };
    }

    if (btnToggleOverlayWechat) {
      btnToggleOverlayWechat.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isOverlayWechatToggled = !isOverlayWechatToggled;
        updateOverlayWechatState();
      };
    }
    if (btnCloseOverlayWechat) {
      btnCloseOverlayWechat.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isOverlayWechatToggled = !isOverlayWechatToggled;
        updateOverlayWechatState();
      };
    }

  };

  const updateOverlayState = () => {
    if (isOverlayToggled) {
      overlay.setAttribute("aria-hidden", false);
      overlay.setAttribute("data-state", "open");
      document.body.setAttribute("data-overlay-open", "true");
    } else {
      overlay.setAttribute("aria-hidden", true);
      overlay.setAttribute("data-state", "closed");
      document.body.setAttribute("data-overlay-open", "false");
    }
  };

  const updateOverlayWechatState = () => {
    if (isOverlayWechatToggled) {
      overlayWechat.setAttribute("aria-hidden", false);
      overlayWechat.setAttribute("data-state", "open");
      document.body.setAttribute("data-overlay-open", "true");
    } else {
      overlayWechat.setAttribute("aria-hidden", true);
      overlayWechat.setAttribute("data-state", "closed");
      document.body.setAttribute("data-overlay-open", "false");
    }
  };

  init();
};
